module.exports = __webpack_public_path__ + "static/media/ImpactReport22-en.86d633c3.pdf";